import {
  IconRss,
  IconArrowsShuffle,
  IconBookmark,
  IconCheck,
  IconAdjustmentsHorizontal,
} from "@tabler/icons-react";
import styles from "../Feed.module.css";
import Button from "../../../../components/UI/Button/button";
import { useNavigate } from "react-router";
import { InfoTooltip } from "../../../../components/UI/FormInput/input";

const TABS = [
  { key: "feed", label: "Feed", icon: IconRss, to: "/talent" },
  {
    key: "matches",
    label: "Matches",
    icon: IconArrowsShuffle,
    to: "/talent?tab=matches&view=list",
  },
  {
    key: "shortlist",
    label: "Shortlist",
    icon: IconBookmark,
    to: "/talent?tab=shortlist",
  },
];

const TalentsToolbar = ({
  activeTab,
  onTabChange,
  counts,
  refine,
  onRefineToggle,
  onOpenAdvanced,
  isCancelMatchBtn = false,
  setCancelShowModal,
}) => {
  const navigate = useNavigate();
  return (
    <div className={styles.toolbar}>
      <div className={styles.tabs}>
        {TABS.map(({ key, label, icon: Icon, to }) => (
          <button
            key={key}
            className={`${styles.tab} ${activeTab === key ? styles.tabActive : ""}`}
            onClick={() => {
              onTabChange(key);
              navigate(to);
            }}
          >
            <Icon size={16} />
            <span className={styles.tabLabel}>{label}</span>
            {/* <span className={styles.tabCount}>{counts[key] ?? 0}</span> */}
          </button>
        ))}
      </div>

      <div className={styles.toolbarRight}>
        <div className={styles.refineWrap}>
          <button
            className={`${styles.refineToggle} ${refine ? styles.refineToggleChecked : ""}`}
            type="button"
            onClick={onRefineToggle}
          >
            <span className={styles.refineBox}>
              <IconCheck size={13} />
            </span>
            Refine
          </button>
          <InfoTooltip text="Refine shows only talents who have completed a verified psychometric assessment on their profile." />
        </div>
        {isCancelMatchBtn && (
          <Button onClick={() => setCancelShowModal(true)}>Cancel Match</Button>
        )}
        <Button
          variant="outlineBlue"
          leftIcon={<IconAdjustmentsHorizontal size={16} />}
          onClick={onOpenAdvanced}
        >
          Advanced Search
        </Button>
      </div>
    </div>
  );
};
export default TalentsToolbar;
